var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {}, [
      _c("div", { staticClass: "flex justify-content-between" }, [
        _c("div", { staticClass: "flex-grow-1" }, [
          _c("h3", { staticClass: "mb-1" }, [
            _vm._v("Препарат: "),
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.task.task_data?.drug?.title ??
                    _vm.record?.drug?.title ??
                    _vm.task?.related_ms_drug?.title
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("i", [
              _vm._v(
                _vm._s(
                  _vm.task.task_data?.drug?.group ??
                    _vm.task?.related_ms_drug?.group
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.task.task_data?.comment
            ? _c("h5", {
                staticClass: "white-space-pre",
                domProps: { innerHTML: _vm._s(_vm.task.task_data.comment) },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.task.id)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      false
        ? _c(
            "div",
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Сохранить задачу",
                  loading: _vm.loading,
                  color: "white",
                  onClick: () => _vm.saveTask(),
                  className: "btn btn-success",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-8" },
        [
          _c("SimpleTaskWithComment", {
            ref: "taskCommentBlock",
            attrs: { task: _vm.task, updateTasks: _vm.updateTasks },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              +_vm.task.status === 0
                ? [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Взять задачу в работу",
                        loading: _vm.loading,
                        color: "white",
                        onClick: () => _vm.saveTask(false, "updateStatus"),
                        className: "btn btn-success",
                      },
                    }),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Статус задачи")]),
                        _vm._v(" "),
                        _c("TasksSubStatuses", {
                          attrs: {
                            type: "select",
                            task: _vm.task,
                            onChange: () =>
                              _vm.saveTask(false, "updateSubStatus"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _vm.task.id && _vm.task.status !== 0
          ? _c("div", { staticClass: "card" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("ShiftTaskActualDate", {
                    ref: "ShiftTaskActualDate",
                    attrs: { "plus-days": 30 },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-right mt-1" },
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Сделать перенос актуальности",
                          loading: _vm.loading,
                          color: _vm.$constants.PRIMARY_COLOR,
                          onClick: () => _vm.saveTask(false, "shiftActualDate"),
                          className: "btn btn-outline-info",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.allowToEdit
      ? _c(
          "div",
          { staticClass: "text-right mt-1" },
          [
            _vm.task.is_active
              ? [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Закрыть задачу",
                      loading: _vm.loading,
                      color: "white",
                      onClick: () => _vm.saveTask(false, "closeTask"),
                      className: "btn btn-outline-success",
                    },
                  }),
                ]
              : [
                  _c("LoadingButton", {
                    attrs: {
                      title:
                        (_vm.task?.id ? "Возобновить" : "Создать") + " задачу",
                      loading: _vm.loading,
                      color: "white",
                      onClick: () =>
                        _vm.saveTask(
                          false,
                          _vm.task?.id ? "reActive" : "newTask"
                        ),
                      className: "btn btn-success",
                    },
                  }),
                ],
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _c("div", { staticClass: "card-header bg_green" }, [
        _c("h4", [_vm._v("Выбор производителя")]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex justify-content-between" },
          [
            _vm.task.manufacturer_id
              ? [
                  _c("div", { staticClass: "flex-grow-1" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.selectedManufacturer?.title)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        on: {
                          click: function ($event) {
                            _vm.showEditBlock = !_vm.showEditBlock
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.showEditBlock
                                ? "Скрыть"
                                : "Редактировать производителя"
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            !_vm.task.manufacturer_id && !_vm.showEditBlock
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      on: {
                        click: function ($event) {
                          _vm.showEditBlock = !_vm.showEditBlock
                        },
                      },
                    },
                    [_vm._v("Выбрать производителя")]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showEditBlock
        ? _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.selectedManufacturer
                ? _c("EditManufacturer", {
                    attrs: {
                      savedManufacturer: _vm.selectedManufacturer,
                      onSelectManufacturer: (m) =>
                        _vm.updateManufacturerInTask(m),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "mt-1" }, [
                _c("label", [_vm._v("Выбрать производителя")]),
                _vm._v(" "),
                _c("div", { staticClass: "flex" }, [
                  _c(
                    "div",
                    { staticClass: "flex-grow-1" },
                    [
                      _c("Search", {
                        ref: "search",
                        attrs: {
                          customPreset: { placeholder: "Поиск производителя" },
                          searchType: "manufacturer",
                          onSelect: (m) => _vm.addNewManufacturer(m),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.addNewManufacturer()
                        },
                      },
                    },
                    [_vm._v("Создать нового")]
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-dark" }, [
      _c("h6", [_vm._v("Перенос даты актуальности")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }